import { render, staticRenderFns } from "./common.vue?vue&type=template&id=0c84b288"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"
import style0 from "./common.vue?vue&type=style&index=0&id=0c84b288&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports